module.exports = __webpack_public_path__ + "img/config_carousel_04.0b4a0f84.jpg";